export enum PracticeArea {
  CorporateAndCommercial = 'CorporateAndCommercial',
  DataPrivacyAndCybersecurity = 'DataPrivacyAndCybersecurity',
  Energy = 'Energy',
  Finance = 'Finance',
  HealthcareAndLifeSciences = 'HealthcareAndLifeSciences',
  IntellectualProperty = 'IntellectualProperty',
  LaborAndEmployment = 'LaborAndEmployment',
  LitigationAndDisputeResolution = 'LitigationAndDisputeResolution',
  MergersAndAcquisitions = 'MergersAndAcquisitions',
  RealEstate = 'RealEstate',
  RegulatoryAndCompliance = 'RegulatoryAndCompliance',
  Tax = 'Tax',
  Technology = 'Technology',
}
